import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import FlatButton from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import axios from 'axios';
import { translate } from 'react-admin';
import download from 'downloadjs';
import { refreshView as refreshViewAction } from 'react-admin';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DownloadIcon from '@material-ui/icons/GetApp';

class PdfDownloadButton extends Component {
    state = {
        open: false,
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    handleCancel = () => {
        this.setState({open: false});
    };

    handleWithHead = () => {
        this.startDownload(true);
        this.setState({open: false});
    };

    handleWithoutHead = () => {
        this.startDownload(false);
        this.setState({open: false});
    };

    startDownload = (withHead) => {
        const { record, recordId, fileName, controller, refreshView } = this.props;
        console.log(record);

        const authToken = localStorage.getItem('token');
        let url = '/api/pdf/' + controller + '/';
        let id = typeof record !== 'undefined' ? record.id : recordId;
        let fn = typeof record !== 'undefined' ? 'R'+record.orderNumber : fileName;

        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.invoicePk !== 'undefined') {
        //     id = record.invoicePk;
        // }

        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.invoice !== 'undefined') {
        //     id = record.invoice.id;
        //     fn = 'R'+record.invoice.invoiceNumber;
        // }

        // if(controller === 'pdfInvoiceDraftDownload' && typeof record !== 'undefined' && typeof record.invoice !== 'undefined') {
        //     id = record.invoice.id;
        //     fn = 'E'+record.invoice.invoiceNumber;
        // }

        // if(controller === 'pdfInvoiceDocumentsDownload' && typeof record !== 'undefined') {
        //     fn = 'R'+record.invoiceNumber+'-LS-RWS';
        // }

        // if(controller === 'api/pdf/spi') {
        //     fn = typeof record !== 'undefined' ? 'L'+record.orderNumber : fileName;
        // }

        // if(controller === 'pdfOrderFromOrderDownload') {
        //     id = record.cart.id;
        //     fn = typeof record !== 'undefined' ? 'L'+record.orderNumber : fileName;
        //     url = 'api/pdf/spi';
        // }

        // if(controller === 'api/pdf/spi') {
        //     fn = typeof record !== 'undefined' ? 'R'+record.transactionNumber : fileName;
        // }

        // if(controller === 'api/pdf/spi') {
        //     fn = typeof record !== 'undefined' ? 'B'+record.orderNumber : fileName;
        // }

        // if(controller === 'pdfReturnShipmentDownload') {
        //     fn = typeof record !== 'undefined' ? 'RWS'+record.returnShipmentNumber : fileName;
        // }

        axios({
            url: url + id,
            method: 'get',
            responseType: 'blob',
            headers: {
                Authorization: authToken,
                Accept: 'application/json',
            },
        }).then(response => {
            let filename = fn+'.pdf';
            download(response.data, filename);
            refreshView();
        }).catch((error) => {
            console.log(error);
        });
    };

    render() {
        const {translate,label,icon,record,controller,labeled,disabled,disabledReason} = this.props;
        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.invoicePk !== 'undefined' && record.invoicePk === 0) {
        //     return null;
        // }
        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.invoicePk !== 'undefined' && record.invoiceNumber === null) {
        //     return null;
        // }

        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.rksvSigningPending !== 'undefined' && record.rksvSigningPending === true) {
        //     return null;
        // }
        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.rksvSigningFailed !== 'undefined' && record.rksvSigningFailed === true) {
        //     return null;
        // }
        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.invoice !== 'undefined' && record.invoice === null) {
        //     return null;
        // }
        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.invoice !== 'undefined' &&  typeof record.invoice.rksvSigningPending !== 'undefined' && record.invoice.rksvSigningPending === true) {
        //     return null;
        // }
        // if(controller === 'pdfInvoiceDownload' && typeof record !== 'undefined' && typeof record.invoice !== 'undefined' && typeof record.invoice.rksvSigningFailed !== 'undefined' && record.invoice.rksvSigningFailed === true) {
        //     return null;
        // }
        // if(controller === 'pdfInvoiceDocumentsDownload' && typeof record == 'undefined'    ) {
        //     return null;
        // }
        const actions = [
            <Button
                primary={true}
                onClick={this.handleWithHead}
                >Prenos</Button>,
            // <Button
            //     primary={true}
            //     onClick={this.handleWithoutHead}
            // >{translate('download.withoutHead')}</Button>,
            <Button
                primary={true}
                onClick={this.handleCancel}
                >Prekliči</Button>,
        ];
        return (
            <div style={labeled ? { display: 'inline-block' } : undefined}>
                {labeled ? (
                    // a disabled button gets no mouse events, so the tooltip sits on a wrapper
                    <Tooltip title={disabled && disabledReason ? disabledReason : ''}>
                        <span style={{ display: 'inline-block' }}>
                            <Button color="primary" onClick={this.handleOpen} disabled={disabled}>
                                <DownloadIcon style={{ marginRight: 6, fontSize: 20 }} />
                                Prenesi PDF
                            </Button>
                        </span>
                    </Tooltip>
                ) : (
                    <Tooltip title="Prenesi PDF">
                        <IconButton color="primary" aria-label="Prenesi PDF" onClick={this.handleOpen}>
                            <DownloadIcon />
                        </IconButton>
                    </Tooltip>
                )}
                <Dialog
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                >
                <DialogTitle>
                   Prenos PDF
                </DialogTitle>
                <DialogContent>Potrdi za prenos PDF dokumenta.</DialogContent>
                <DialogActions>{actions}</DialogActions>
                </Dialog>
            </div>
        );
    };
}

PdfDownloadButton.propTypes = {
    record: PropTypes.object,
    recordId: PropTypes.number,
    fileName: PropTypes.string,
    label: PropTypes.string,
    controller: PropTypes.string,
    labeled: PropTypes.bool,
    disabled: PropTypes.bool,
    disabledReason: PropTypes.string,
};

const enhance = compose(
    translate,
    connect(null, {
        refreshView: refreshViewAction,
    }),
);

export default enhance(PdfDownloadButton); 